import React, { FunctionComponent } from 'react';

import { StyledDropdown, StyledDropdownContainer, StyledLabel } from './dropdown.styled';

interface Option {
  label: string;
  value: string | number;
}

interface OwnProps {
  label: string;
  onChange: (value: string) => void;
  options: Option[];
}

type Props = OwnProps & Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'onChange'>;

export const Dropdown: FunctionComponent<Props> = (props) => {
  const { options, label, onChange, ...rest } = props;

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    if (event) {
      onChange(event.target.value);
    }
  };

  return (
    <StyledDropdownContainer>
      <StyledLabel variant="paragraph2" component="p">
        {label}
      </StyledLabel>
      <StyledDropdown {...rest} onChange={handleChange}>
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </StyledDropdown>
    </StyledDropdownContainer>
  );
};
